module.exports = __webpack_public_path__ + "static/media/global.598f65cb.png";